/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AppShoppingIndexRouteImport } from './routes/_app/shopping/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppLabelsIndexRouteImport } from './routes/_app/labels/index'
import { Route as AppShoppingPickRouteImport } from './routes/_app/shopping/pick'
import { Route as AppShoppingNewRouteImport } from './routes/_app/shopping/new'
import { Route as AppShoppingSessionIdRouteImport } from './routes/_app/shopping/$sessionId'
import { Route as AppSettingsVenuesRouteImport } from './routes/_app/settings/venues'
import { Route as AppLabelsLabelIdRouteImport } from './routes/_app/labels/$labelId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppShoppingIndexRoute = AppShoppingIndexRouteImport.update({
  id: '/shopping/',
  path: '/shopping/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppLabelsIndexRoute = AppLabelsIndexRouteImport.update({
  id: '/labels/',
  path: '/labels/',
  getParentRoute: () => AppRoute,
} as any)
const AppShoppingPickRoute = AppShoppingPickRouteImport.update({
  id: '/shopping/pick',
  path: '/shopping/pick',
  getParentRoute: () => AppRoute,
} as any)
const AppShoppingNewRoute = AppShoppingNewRouteImport.update({
  id: '/shopping/new',
  path: '/shopping/new',
  getParentRoute: () => AppRoute,
} as any)
const AppShoppingSessionIdRoute = AppShoppingSessionIdRouteImport.update({
  id: '/shopping/$sessionId',
  path: '/shopping/$sessionId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsVenuesRoute = AppSettingsVenuesRouteImport.update({
  id: '/settings/venues',
  path: '/settings/venues',
  getParentRoute: () => AppRoute,
} as any)
const AppLabelsLabelIdRoute = AppLabelsLabelIdRouteImport.update({
  id: '/labels/$labelId',
  path: '/labels/$labelId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/labels/$labelId': typeof AppLabelsLabelIdRoute
  '/settings/venues': typeof AppSettingsVenuesRoute
  '/shopping/$sessionId': typeof AppShoppingSessionIdRoute
  '/shopping/new': typeof AppShoppingNewRoute
  '/shopping/pick': typeof AppShoppingPickRoute
  '/labels/': typeof AppLabelsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/shopping/': typeof AppShoppingIndexRoute
}
export interface FileRoutesByTo {
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AppIndexRoute
  '/labels/$labelId': typeof AppLabelsLabelIdRoute
  '/settings/venues': typeof AppSettingsVenuesRoute
  '/shopping/$sessionId': typeof AppShoppingSessionIdRoute
  '/shopping/new': typeof AppShoppingNewRoute
  '/shopping/pick': typeof AppShoppingPickRoute
  '/labels': typeof AppLabelsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/shopping': typeof AppShoppingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/labels/$labelId': typeof AppLabelsLabelIdRoute
  '/_app/settings/venues': typeof AppSettingsVenuesRoute
  '/_app/shopping/$sessionId': typeof AppShoppingSessionIdRoute
  '/_app/shopping/new': typeof AppShoppingNewRoute
  '/_app/shopping/pick': typeof AppShoppingPickRoute
  '/_app/labels/': typeof AppLabelsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/shopping/': typeof AppShoppingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth/callback'
    | '/labels/$labelId'
    | '/settings/venues'
    | '/shopping/$sessionId'
    | '/shopping/new'
    | '/shopping/pick'
    | '/labels/'
    | '/settings/'
    | '/shopping/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth/callback'
    | '/'
    | '/labels/$labelId'
    | '/settings/venues'
    | '/shopping/$sessionId'
    | '/shopping/new'
    | '/shopping/pick'
    | '/labels'
    | '/settings'
    | '/shopping'
  id:
    | '__root__'
    | '/_app'
    | '/auth/callback'
    | '/_app/'
    | '/_app/labels/$labelId'
    | '/_app/settings/venues'
    | '/_app/shopping/$sessionId'
    | '/_app/shopping/new'
    | '/_app/shopping/pick'
    | '/_app/labels/'
    | '/_app/settings/'
    | '/_app/shopping/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/shopping/': {
      id: '/_app/shopping/'
      path: '/shopping'
      fullPath: '/shopping/'
      preLoaderRoute: typeof AppShoppingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/labels/': {
      id: '/_app/labels/'
      path: '/labels'
      fullPath: '/labels/'
      preLoaderRoute: typeof AppLabelsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shopping/pick': {
      id: '/_app/shopping/pick'
      path: '/shopping/pick'
      fullPath: '/shopping/pick'
      preLoaderRoute: typeof AppShoppingPickRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shopping/new': {
      id: '/_app/shopping/new'
      path: '/shopping/new'
      fullPath: '/shopping/new'
      preLoaderRoute: typeof AppShoppingNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shopping/$sessionId': {
      id: '/_app/shopping/$sessionId'
      path: '/shopping/$sessionId'
      fullPath: '/shopping/$sessionId'
      preLoaderRoute: typeof AppShoppingSessionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/venues': {
      id: '/_app/settings/venues'
      path: '/settings/venues'
      fullPath: '/settings/venues'
      preLoaderRoute: typeof AppSettingsVenuesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/labels/$labelId': {
      id: '/_app/labels/$labelId'
      path: '/labels/$labelId'
      fullPath: '/labels/$labelId'
      preLoaderRoute: typeof AppLabelsLabelIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppLabelsLabelIdRoute: typeof AppLabelsLabelIdRoute
  AppSettingsVenuesRoute: typeof AppSettingsVenuesRoute
  AppShoppingSessionIdRoute: typeof AppShoppingSessionIdRoute
  AppShoppingNewRoute: typeof AppShoppingNewRoute
  AppShoppingPickRoute: typeof AppShoppingPickRoute
  AppLabelsIndexRoute: typeof AppLabelsIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppShoppingIndexRoute: typeof AppShoppingIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppLabelsLabelIdRoute: AppLabelsLabelIdRoute,
  AppSettingsVenuesRoute: AppSettingsVenuesRoute,
  AppShoppingSessionIdRoute: AppShoppingSessionIdRoute,
  AppShoppingNewRoute: AppShoppingNewRoute,
  AppShoppingPickRoute: AppShoppingPickRoute,
  AppLabelsIndexRoute: AppLabelsIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppShoppingIndexRoute: AppShoppingIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
